import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router'
import z from 'zod'
import type { WorkOrderListItem } from '@/api/hooks/useWorkOrders'
import { WorkOrderModal } from '@/components/organisms/work-order-modal/work-order-modal'
import { Dialog } from '@/components/ui/dialog'

const searchSchema = z.object({
  planDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
})

export const Route = createFileRoute('/_authenticated/planning/workorder/$workOrderId')({
  validateSearch: searchSchema,
  component: WorkOrderModalRoute,
})

function WorkOrderModalRoute() {
  const { workOrderId } = Route.useParams()
  const { planDate } = Route.useSearch()
  const navigate = useNavigate()
  const location = useLocation()
  const initialWorkOrder = (location.state as { initialWorkOrder?: WorkOrderListItem } | undefined)
    ?.initialWorkOrder

  return (
    <Dialog open onOpenChange={() => navigate({ to: '/planning' })}>
      <WorkOrderModal
        initialWorkOrder={initialWorkOrder}
        planDate={planDate}
        workOrderId={workOrderId}
      />
    </Dialog>
  )
}
